import {
  FACET_DESCRIPTORS,
  buildFacetGroups,
  findFacetGroup,
  isIndexableFacetGroup,
  slugifyFacetValue,
  MIN_ANTIBODIES_PER_FACET,
} from 'components/AntibodiesList/antibodyFacetConfig.mjs';
import {
  IHC_ANTIBODIES_APPLICATION_URL,
  IHC_ANTIBODIES_MANUFACTURER_URL,
  IHC_ANTIBODIES_SPECIES_URL,
  IHC_ANTIBODIES_BASE_URL,
} from 'constants/urls';

// The facet data and the grouping rules live in antibodyFacetConfig.mjs, which the sitemap
// build script shares, so the two cannot drift apart. Re-exported here so callers have a
// single import for everything facet-related.
export {
  MIN_ANTIBODIES_PER_FACET,
  buildFacetGroups,
  findFacetGroup,
  isIndexableFacetGroup,
  slugifyFacetValue,
};

// The presentational half of each facet: where its listing lives and how it reads.
const FACET_PRESENTATION = {
  applications: {
    route: IHC_ANTIBODIES_APPLICATION_URL,
    listLabel: 'Application',
    listHeading: 'Browse by application',
    getHeading: (value) => `IHC Antibodies Validated for ${value}`,
  },
  species: {
    route: IHC_ANTIBODIES_SPECIES_URL,
    listLabel: 'Validated Species',
    listHeading: 'Browse by validated species',
    getHeading: (value) => `IHC Antibodies Validated in ${value}`,
  },
  manufacturers: {
    route: IHC_ANTIBODIES_MANUFACTURER_URL,
    listLabel: 'Manufacturer',
    listHeading: 'Browse by manufacturer',
    getHeading: (value) => `${value} IHC Antibodies Validated by HistoWiz`,
  },
};

export const FACETS = FACET_DESCRIPTORS.map((descriptor) => ({
  ...descriptor,
  ...FACET_PRESENTATION[descriptor.segment],
}));

export const getFacetUrl = (facet, slug) =>
  `${IHC_ANTIBODIES_BASE_URL}${facet.segment}/${slug}`;
